export const MODULE_NAME = 'PROPERTY_MODULE';
